import { useEffect, useMemo } from 'react';
import { XSquare } from "react-bootstrap-icons";
import { isStepDataEmpty } from '../../utils/utils';

export const useStepDataProtection = (allStepData, resultGet, test_kit_id, location, navigate, showToast) => {
  const hasStepData = useMemo(() =>
    allStepData && Object.keys(allStepData).length > 0,
    [allStepData]
  );

  // Handle data loss warning on reload
  useEffect(() => {
    const isInitialReload = performance.getEntriesByType("navigation")[0]?.type === "reload";

    if (
      isInitialReload &&
      !resultGet?.assessment_values &&
      isStepDataEmpty(allStepData)
    ) {
      showToast?.(
        "Data Lost",
        "Previous step data is missing. Please complete the assessment steps again.",
        "../assets/mhc.png",
        <XSquare />
      );
      const kitId =
        test_kit_id ||
        location?.state?.test_kit_id ||
        localStorage.getItem("test_kit_id");

      if (kitId) {
        if (localStorage.getItem("is_phlebotomist") === "true") {
          navigate?.(`/bloods/boots/assessment/${localStorage.getItem("test_type")}/${kitId}/1`);
        }
        else {
          navigate?.(`/assessment/${test_kit_id || location?.state?.test_kit_id}/1`);
        }
      }

    }
  }, [resultGet, allStepData, test_kit_id, location?.state?.test_kit_id, navigate, showToast]);

  // Warn user on page unload if there is unsaved data
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasStepData) {
        e.preventDefault();
        e.returnValue = ""; // Required for Chrome
      }
    };

    if (hasStepData) {
      globalThis.addEventListener("beforeunload", handleBeforeUnload);
      return () => {
        globalThis.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }
  }, [hasStepData]);
};